/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EntityMediaResponse } from '../../models/entity-media-response';
import { EnumMediaEntities } from '../../models/enum-media-entities';

export interface EntityMediaControllerGetEntityFiles$Params {
  entity: EnumMediaEntities;
  entityId: number;

/**
 * Filtra per tipologia
 */
  mediaTypeId?: number;
  limit?: number;
  skip?: number;
}

export function entityMediaControllerGetEntityFiles(http: HttpClient, rootUrl: string, params: EntityMediaControllerGetEntityFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, entityMediaControllerGetEntityFiles.PATH, 'get');
  if (params) {
    rb.path('entity', params.entity, {});
    rb.path('entityId', params.entityId, {});
    rb.query('mediaTypeId', params.mediaTypeId, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EntityMediaResponse;
      }>;
    })
  );
}

entityMediaControllerGetEntityFiles.PATH = '/file-manager/{entity}/{entityId}';
